// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3bsxM","row":"styles_row__30kaL"};